import { GetStartedStepState } from '../types'

export const calcStatesProgress = (states: Record<string, GetStartedStepState>) => {
  const completed = Object.values(states).filter(state => state.status === 'completed').length
  const total = Object.values(states).length
  return { completed, total }
}
